import Button from "../atoms/button";
import { formatPackageItemsSummary } from "./packageItems";

const formatCents = (value) => new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
}).format(Number(value || 0) / 100);

const formatDate = (value) => {
    if (!value) {
        return "-";
    }
    return new Intl.DateTimeFormat("pt-BR").format(new Date(value));
};

const ProductPackagesList = ({ packages = [], onCreate, onEdit }) => (
    <section className="mt-4 rounded border border-[#d59106] bg-black text-primary">
        <div className="flex flex-wrap items-center justify-between gap-3 border-b border-[#d59106]/60 p-3">
            <div className="text-left">
                <h2 className="text-xl font-semibold text-[#d59106]">Pacotes promocionais</h2>
                <p className="text-sm text-primary/70">{packages.length} pacote(s) encontrado(s)</p>
            </div>
            <Button classes="bg-[#d59106] hover:bg-[#b47c06]" click={onCreate}>Criar pacote</Button>
        </div>

        <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-[#d59106]/40 text-left text-sm">
                <thead className="bg-[#111] text-[#d59106]">
                    <tr>
                        <th className="px-3 py-2">Nome</th>
                        <th className="px-3 py-2">Slug</th>
                        <th className="px-3 py-2">Tipo + qtd</th>
                        <th className="px-3 py-2">Preço</th>
                        <th className="px-3 py-2">Prazo</th>
                        <th className="px-3 py-2">Ativo</th>
                        <th className="px-3 py-2">Vigência</th>
                        <th className="px-3 py-2">Ações</th>
                    </tr>
                </thead>
                <tbody className="divide-y divide-[#d59106]/20">
                    {packages.map((item) => (
                        <tr key={item._id || item.id} className="hover:bg-[#d59106]/10">
                            <td className="px-3 py-3">
                                <p className="font-semibold text-primary">{item.internalName}</p>
                                <p className="text-xs text-primary/60">{item.title}</p>
                            </td>
                            <td className="px-3 py-3 font-mono text-xs">{item.slug}</td>
                            <td className="px-3 py-3">
                                {formatPackageItemsSummary(item)}
                            </td>
                            <td className="px-3 py-3">{formatCents(item.promoPriceCents)}</td>
                            <td className="px-3 py-3">{item.promoDeadlineBusinessDays} dias úteis</td>
                            <td className="px-3 py-3">
                                <span className={item.isActive ? "text-green-400" : "text-red-400"}>
                                    {item.isActive ? "Sim" : "Não"}
                                </span>
                            </td>
                            <td className="px-3 py-3 text-xs">
                                {formatDate(item.startsAt)} até {formatDate(item.endsAt)}
                            </td>
                            <td className="px-3 py-3">
                                <button
                                    type="button"
                                    onClick={() => onEdit(item)}
                                    className="rounded bg-blue-500 px-3 py-1 text-black hover:bg-blue-400"
                                >
                                    Editar
                                </button>
                            </td>
                        </tr>
                    ))}
                    {!packages.length ? (
                        <tr>
                            <td colSpan="8" className="px-3 py-8 text-center text-primary/70">
                                Nenhum pacote encontrado.
                            </td>
                        </tr>
                    ) : null}
                </tbody>
            </table>
        </div>
    </section>
);

export default ProductPackagesList;
